// @flow

import * as colorsStyles from './colors'
import * as mixinStyles from './mixins'
import * as commonStyles from './common'

export const colors = colorsStyles
export const mixins = mixinStyles
export const common = commonStyles
